import FastingBody from './FastingBody';

export default FastingBody;
